<form class="form-vertical" id="editshareform" data-hook="editshareform">
    <div class="form-group">
      <label for="sharename">Name</label>
      <input type="text" ng-model="vm.share.name" class="form-control" id="sharename">
    </div>
    <div class="form-group">
      <label for="sharepath">Pfad</label>
      <input type="text" ng-model="vm.share.path" class="form-control" id="sharepath">
    </div>
    <div class="form-group">
      <label for="sharedesc">Beschreibung</label>
      <input type="text" ng-model="vm.share.desc" class="form-control" id="sharedesc">
    </div>
    <div class="form-group">
      <label for="sharetype">Sharetype</label>
      <select class="form-control" id="sharetype" ng-model="vm.share.sharetype">
        <option>scan</option>
        <option>gdt</option>
        <option>generic</option>
      </select>
    </div>
    <div class="form-group">
      <label for="mimetype">Filetyp</label>
      <select class="form-control" id="mimetype" ng-model="vm.share.filetype">
        <option>image/jpeg</option>
        <option>image/gif</option>
        <option>image/tiff</option>
        <option>application/pdf</option>
        <option>video/mpeg</option>
        <option>audio/mpeg3</option>
      </select>
    </div>

  
  <div class=" row">
    <div class="col-xs-12">
      <div class="form-group">
        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
      </div>
    </div>
  </div>
</form>